const { getDateInstance } = require('./getDateInstance')

/**
 * A megadott nap a mai nap?
 * @param {string | number | Date} date - A dátum paraméter.
 * @returns {boolean} Ma már máma van már?
 */
module.exports.isToday = function isToday (date) {
  const today = new Date()
  const givenDate = getDateInstance(date)

  const isTruthy = today.toDateString() === givenDate.toDateString()

  return isTruthy
}
